import axios from 'axios';
import {
    PARTNERSHIP_API,
    API_HEADER
} from '../../../constants/API'
import {
    CANCEL_PARTNERSHIP_LOADING
} from '../types';
import { message } from 'antd';

export default (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: CANCEL_PARTNERSHIP_LOADING,
                cancellingPartnership: true
            })
            const { token } = getState().UserReducer;
            await axios.get(`${PARTNERSHIP_API}/cancel/${id}`, API_HEADER(token))
            dispatch({
                type: CANCEL_PARTNERSHIP_LOADING,
                cancellingPartnership: false
            })
        } catch(e) {
            if (e && e.response && e.response.data) {
                message.error(String(e.response.data))
            }            
            dispatch({
                type: CANCEL_PARTNERSHIP_LOADING,
                cancellingPartnership: false
            })

        }
    }
}